import { motion } from "framer-motion";

function ShipEngineLayout() {
    return (
      <div className="flex flex-col gap-2 w-48">
        {/* Top image */}
        <div className="relative h-12 bg-black rounded-lg border border-blue-500 overflow-hidden">
          <img
            src="/images/ship-engine.png"
            alt="Top Engine Diagram"
            className="w-full h-full object-contain opacity-80"
          />
          {/* Example glowing dot for top */}
          <motion.div
            className="absolute border border-green-400 rounded-sm w-6 h-2 top-5 left-4"
            animate={{ opacity: [0, 1, 0] }}
            transition={{ repeat: Infinity, duration: 2 }}
            />
            {/* Vertical scan line on the right */}
            <motion.div
                className="absolute w-0.5 h-full right-2 top-0 bg-green-400/30"
                animate={{ opacity: [0, 0.4, 1, 0.4, 0] }}
                transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            />
             {/* Random green dot pulses */}
                {[...Array(8)].map((_, i) => {
                    const top = Math.random() * 90 + 2; // between 2% and 92%
                    const left = Math.random() * 90 + 2;
                    return (
                    <motion.div
                        key={i}
                        className="absolute w-[3px] h-[3px] bg-green-300 rounded-full"
                        style={{ top: `${top}%`, left: `${left}%` }}
                        animate={{ opacity: [0, 1, 0] }}
                        transition={{ duration: 1 + Math.random(), repeat: Infinity, delay: Math.random() * 2 }}
                    />
                    );
                })}
        </div>
  
        {/* Bottom image */}
        <div className="relative h-12 bg-black rounded-lg border border-blue-500 overflow-hidden">
          <img
            src="/images/ship-engine-two.png"
            alt="Bottom Engine Diagram"
            className="w-full h-full object-contain opacity-80 scale-x-[-1]"
          />
          {/* Example glowing dot for bottom */}
          <motion.div
            className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-cyan-400/10 to-transparent"
            animate={{ x: ['-100%', '100%'] }}
            transition={{ repeat: Infinity, duration: 3, ease: 'linear' }}
            />
        </div>
      </div>
    );
  }
  
export default ShipEngineLayout;
